export default {
  name: 'AuthHeader'
};
